﻿import { initPhotoSwipe } from './_photoswipe-init';
import hljs from 'highlight.js';
import hljsRazor from 'highlightjs-cshtml-razor';

document.addEventListener('DOMContentLoaded', () => {
    initPhotoSwipe();
    hljs.registerLanguage("cshtml-razor", hljsRazor);
    hljs.highlightAll();
});